import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("*")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("*")
const _hoisted_4 = { class: "ion-padding" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/store';
import { translate } from '@/i18n';
import { showToast, isValidEmail, isValidPassword } from '@/utils';
import logger from '@/logger';
import Logo from '@/components/Logo.vue';
import {
  IonButton,
  IonCard,
  IonContent,
  IonInput,
  IonItem,
  IonPage,
  IonText
} from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();

const registerData = ref({
  userFullName: '',
  emailAddress: '',
  organizationName: '',
  username: '',
  contactNumber: '',
  newPassword: '',
  newPasswordVerify: ''
});

function validateCreateUserDetail(): string | null {

  if(!registerData.value.userFullName?.trim()) {
    return (translate("Name is required."));
  }
  if(!registerData.value.emailAddress) {
    return (translate("Email address is required."));
  }
  if(registerData.value.emailAddress && !isValidEmail(registerData.value.emailAddress)) {
    return (translate("Invalid email address."));
  }
  if(registerData.value.newPassword && !isValidPassword(registerData.value.newPassword)) {
    return (translate("Password is not valid"));
  }
  if(registerData.value.newPassword &&registerData.value.newPasswordVerify && registerData.value.newPassword !== registerData.value.newPasswordVerify) {
    return (translate("Password is not matching with confirm password."));
  }

  return null;
}
// TODO: userRegister function is not functional yet, need to implement the API call
async function userRegister() {
  try {
    const validationErrors = validateCreateUserDetail();

    if(validationErrors) {
      const errorMessages = validationErrors;
      logger.error(errorMessages);
      showToast(errorMessages);
      return;
    }

    const payload = registerData.value;

    const response: any = await store.dispatch('user/register', payload);
    
    if (response) {
      showToast(translate('User registered successfully'));
      router.push('/login');
    }

  } catch (err: any) {
    let errorMessage = "Failed to create user.";
    if(err?.response?.data?.error?.message) {
      errorMessage = err.response.data.error.message;
    }
    logger.error(err);
    showToast(errorMessage);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonCard), null, {
              default: _withCtx(() => [
                _createElementVNode("form", {
                  class: "form-card",
                  onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (userRegister(_ctx.form)), ["enter"])),
                  onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (userRegister(_ctx.form)), ["prevent"]))
                }, [
                  _createVNode(Logo),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        "label-placement": "floating",
                        label: _unref(translate)('Full Name'),
                        modelValue: registerData.value.userFullName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((registerData.value.userFullName) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonText), { color: "danger" }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        "label-placement": "floating",
                        label: _unref(translate)('Email Address'),
                        modelValue: registerData.value.emailAddress,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((registerData.value.emailAddress) = $event)),
                        type: "email"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonText), { color: "danger" }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        "label-placement": "floating",
                        label: _unref(translate)('Organization Name'),
                        modelValue: registerData.value.organizationName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registerData.value.organizationName) = $event)),
                        type: "text"
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        "label-placement": "floating",
                        label: _unref(translate)('Username'),
                        modelValue: registerData.value.username,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((registerData.value.username) = $event)),
                        type: "text"
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        "label-placement": "floating",
                        label: _unref(translate)('Contact Number'),
                        modelValue: registerData.value.contactNumber,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((registerData.value.contactNumber) = $event)),
                        type: "number"
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        "label-placement": "floating",
                        label: _unref(translate)('Password'),
                        name: "password",
                        modelValue: registerData.value.newPassword,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((registerData.value.newPassword) = $event)),
                        id: "password",
                        type: "password",
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        "label-placement": "floating",
                        label: _unref(translate)('Confirm Password'),
                        name: "password",
                        modelValue: registerData.value.newPasswordVerify,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((registerData.value.newPasswordVerify) = $event)),
                        id: "password",
                        type: "password",
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(IonButton), {
                      type: "submit",
                      expand: "block"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Register")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonButton), {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(router).push('/login'))),
                      fill: "clear",
                      expand: "block"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Back to Login")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ], 32)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})